import { CardWithTitle } from 'commons/components';
import Text from 'commons/components/LegacyText';
import Stack from 'commons/components/Stack';

function Skeleton() {
  return (
    <CardWithTitle>
      <Stack column align="stretch" spacing="tight">
        <Stack wrap justify="space-between">
          <Text.Skeleton size="caption" />
          <Text.Skeleton size="caption" width="small" />
        </Stack>
        <Stack wrap justify="space-between">
          <Text.Skeleton size="caption" />
          <Text.Skeleton size="caption" width="small" />
        </Stack>
        <Stack wrap justify="space-between">
          <Text.Skeleton size="caption" />
          <Text.Skeleton size="caption" width="small" />
        </Stack>
      </Stack>
    </CardWithTitle>
  );
}

export default Skeleton;
